import { Directive, forwardRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[nesFormControl]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NesFormControlDirective),
      multi: true,
    },
  ],
})
export class NesFormControlDirective implements ControlValueAccessor {
  onChange: Function = () => {};
  onTouched: Function = () => {};

  private _value = '';
  get value() {
    return this._value;
  }

  set value(value) {
    if (value !== this._value) {
      this._value = value;
      this.onChange(this._value);
    }
  }

  writeValue(value: string) {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn: Function) {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function) {
    this.onTouched = fn;
  }

  @HostListener('nesOnChange', ['$event.detail.value'])
  listenForValueChange(value: string) {
    this.value = value;
  }

  @HostListener('nesOnBlur')
  listenOnBlur() {
    this.onTouched();
  }
}